import React from "react"

import Header from "./Header";
import { useMeMutation} from "./query";
import CardBasicInfo from "./CardBasicInfo";

import Container from "@mui/material/Container";
import CardPassword from "./CardPassword";
import {Grid} from "@mui/material";
import CardApiKey from "./CardApiKey";
import CardContact from "./CardContact";
import {useCurrentUser} from "../../auth/CurrentUserProvider";



const UserAccount = () => {
    const {currentUser: userQuery} = useCurrentUser();

    const userMutation = useMeMutation();
    const userPwdMutation = useMeMutation();
    const userContactMutation = useMeMutation();

    return userQuery.isLoading ?
        null
        :
        <>
            <Header user={userQuery.data}/>
            <Container maxWidth={"xxl"} sx={{mt: 4}}>
                <Grid container columnSpacing={4} rowSpacing={4}>
                    <Grid item xs={12} sm={8} sx={{display: "flex", flexDirection: "column", spacing: 4, rowGap: 4}}>
                        <CardBasicInfo user={userQuery.data} userMutation={userMutation}/>
                        <CardContact user={userQuery.data} userMutation={userContactMutation}/>
                    </Grid>
                    <Grid item xs={12} sm={4} sx={{display: "flex", flexDirection: "column", spacing: 4, rowGap: 4}}>
                        <CardPassword user={userQuery.data} userMutation={userPwdMutation}/>
                        <CardApiKey user={userQuery.data}/>
                    </Grid>
                </Grid>
            </Container>
        </>
}


export default UserAccount;